import React, { Component, Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Resume from '../../assets/documents/troy-evans.pdf'
import data from '../../assets/json/about.json';

class Navigation extends Component {

  render() {
    return (
      <div className="navbar">
        <NavLink exact to="/" className="logo"/>
        <div className="navbar-menu">
          {
            data.nav.links.map(({url, name}) => (
              <Fragment key={name}>
                <NavLink
                  className="navbar-link"
                  activeClassName="active"
                  activeStyle={{ color: '#FC4445' }}
                  to={url}
                >
                    {name}
                </NavLink>
                <div className="border"></div>
              </Fragment>
            ))
          }
          <div className="navbar-link">
            <a href={Resume} target="_blank">Resume</a>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/components/global/Navigation.js